import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';
import { toast } from 'react-toastify';
import moment from 'moment';

import { useDispatch } from 'react-redux';
import {
  updateTrainingRoutineInfo,
  getTrainingRoutineById,
  deleteTrainingRoutine,
} from '~/api';

import Menu from '~/components/Menu';

import EditTrainingRoutineDialog from './EditTrainingRoutineDialog';
import { copyTrainingRoutine } from '~/store/modules/training-routine/actions';

export default function EditMenuTrainingRoutine({
  anchorEl,
  setAnchorEl,
  isOpen,
  trainingRoutineId,
  refreshTrainingRoutines,
}) {
  const dispatch = useDispatch();
  const [editDialogIsOpen, setEditDialogIsOpen] = useState(false);
  const [trainingRoutineToEdit, setTrainingRoutineToEdit] = useState(null);

  const getTrainingRoutine = async () => {
    const { data: trainingRoutine } = await getTrainingRoutineById(
      trainingRoutineId
    );
    setTrainingRoutineToEdit(trainingRoutine);
  };

  useEffect(() => {
    if (isOpen) {
      getTrainingRoutine();
    }
  }, [isOpen]);

  const handleCloseMenu = () => setAnchorEl(null);

  const handleFinishTrainingRoutine = async () => {
    try {
      if (trainingRoutineToEdit?.finishDate) {
        toast.error('Ops, treino já finalizado!');
      } else {
        const today = moment().format('YYYY-MM-DD');
        await updateTrainingRoutineInfo(trainingRoutineId, {
          finishDate: today,
        });
        toast.success('Treino finalizado com sucesso !');

        refreshTrainingRoutines();
      }
    } catch (error) {
      toast.error('Ops, não foi possivel finalizar este treino!');
    }
  };

  const handleDeleteTrainingRoutine = async () => {
    try {
      await deleteTrainingRoutine(trainingRoutineId);
      toast.success('Treino deletado com sucesso !');

      refreshTrainingRoutines();
    } catch {
      toast.error('Ops, não foi possivel deletar este treino!');
    }
  };

  return (
    <>
      <Menu
        id="edit-menu-training-routine"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
      >
        <MenuItem
          onClick={() => dispatch(copyTrainingRoutine(trainingRoutineId))}
        >
          Copiar Treino
        </MenuItem>
        <MenuItem onClick={() => setEditDialogIsOpen(true)}>
          Editar Dados
        </MenuItem>
        <MenuItem onClick={handleFinishTrainingRoutine}>
          Finalizar Treino
        </MenuItem>
        <MenuItem onClick={handleDeleteTrainingRoutine}>
          Deletar Treino
        </MenuItem>
      </Menu>

      {trainingRoutineToEdit && (
        <EditTrainingRoutineDialog
          isOpen={editDialogIsOpen}
          setIsOpen={setEditDialogIsOpen}
          trainingRoutine={trainingRoutineToEdit}
          refreshTrainingRoutines={refreshTrainingRoutines}
        />
      )}
    </>
  );
}

EditMenuTrainingRoutine.propTypes = {
  anchorEl: PropTypes.bool.isRequired,
  setAnchorEl: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  trainingRoutineId: PropTypes.number.isRequired,
  refreshTrainingRoutines: PropTypes.func.isRequired,
};
